import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import './styles/tokens.css';
import { applyTheme, storedTheme } from './lib/theme';
import { captureViewAs } from './lib/impersonation';
import { addFlagFont } from './lib/flags';
import { capturePreview } from './lib/preview';

// Before the first paint, so a dark choice does not flash light.
applyTheme(storedTheme());
// A view-as tab takes its token from the address bar before anything is fetched.
captureViewAs();
// Country flags where the browser draws them as letters (Windows).
addFlagFont();
// An admin's preview of Task Force's free trial keeps to its own tab.
capturePreview();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
